export { TagButton, TagClose, TagDivider, TagWrapper } from "ics-ui-kit/components/tag";
export { Tag } from "./Tag";
